<script lang="ts">
    import { createCalendar, createPagination } from '@melt-ui/svelte';
    import dayjs from 'dayjs';
    import { parseDate } from '@internationalized/date';

    import MinPricePerMonthsList from '$saga/views/Tour/VisibleDates/MinPricePerMonthsList.svelte';
    import {
        findFirstAvailableMonth,
        isDateDisabled as isDateDisabledUtil,
    } from '$saga/utils/date';
    import type {
        MinPriceDays,
        MinPriceMonth,
    } from '$saga/views/Tour/VisibleDates/types';
    import {
        getCurrentDayPriceAmount,
        getQuantileSizeClass,
    } from '$saga/views/Tour/VisibleDates/utils';
    import { dateValue } from '$saga/views/Tour/store';
    import CalendarPicker from '$saga/components/CalendarPicker.svelte';

    export let minPricePerMonths: MinPriceMonth[],
        closedSales,
        minPricePerDays: MinPriceDays,
        isBookable: boolean,
        handleSelectedDate: (date?: string) => void;
    let currentActiveMonth = dayjs();

    const NUMBER_OF_MONTHS = 2;
    const {
        elements: {
            root,
            prevButton: paginationPrev,
            nextButton: paginationNext,
        },
        states: { range, totalPages, page },
    } = createPagination({
        count: minPricePerMonths.length - 1,
        perPage: 6,
    });

    const {
        elements: { calendar, cell, grid, heading, nextButton, prevButton },
        states: { months, headingValue, weekdays },
        helpers: { isDateDisabled, isDateUnavailable, setYear, setMonth },
    } = createCalendar({
        locale: 'fr',
        numberOfMonths: NUMBER_OF_MONTHS,
        minValue: parseDate(dayjs().add(1, 'day').format('YYYY-MM-DD')),
        maxValue: parseDate(
            dayjs().add(minPricePerMonths.length, 'month').format('YYYY-MM-DD'),
        ),
        isDateDisabled: (date) =>
            isDateDisabledUtil(date, closedSales, minPricePerDays),
        value: dateValue,
        onValueChange: (date) => {
            handleSelectedDate(date.next?.toString());
            return date.next;
        },
    });

    // place the first month correctly according to available dates
    currentActiveMonth = findFirstAvailableMonth(closedSales);
    setYear(currentActiveMonth.year());
    setMonth(currentActiveMonth.month() + 1);

    //  when we select a new month in the list
    $: {
        if (currentActiveMonth) {
            setMonth(currentActiveMonth.month() + 1);
            setYear(currentActiveMonth.year());
        }
    }
</script>

<MinPricePerMonthsList
    {root}
    prevButton={paginationPrev}
    nextButton={paginationNext}
    {page}
    {range}
    bind:currentActiveMonth
    {totalPages}
    {minPricePerMonths}
/>

<CalendarPicker
    class="mx-auto !h-full py-m"
    {calendar}
    {prevButton}
    {nextButton}
    {heading}
    {headingValue}
    {months}
    {grid}
    {weekdays}
    {isDateDisabled}
    {isDateUnavailable}
    {cell}
    onPrevButton={() => {
        currentActiveMonth = currentActiveMonth.subtract(1, 'month');
    }}
    onNextButton={() => {
        currentActiveMonth = currentActiveMonth.add(1, 'month');
    }}
    numberOfMonths={NUMBER_OF_MONTHS}
    getDayAdditionalStyle={(date) =>
        getQuantileSizeClass(
            minPricePerDays[dayjs(date.toString()).format('YYYY-MM-DD')]
                ?.quantile,
        )}
    getDayAdditionalContent={(date) =>
        getCurrentDayPriceAmount(minPricePerDays, date)}
/>

{#if !isBookable}
    <div class="w-full text-right text-xs italic">
        les prix indiqués sont "à partir de"
    </div>
{/if}
